/* ==========================================================================
   product-tools.js
   Behavior extracted from inline <script> blocks of templates/product.tools.json.
   - Countdown timer (Price + timer block)
   - scrollToAnchor (rating block — called via inline onclick)
   ========================================================================== */

window.scrollToAnchor = function () {
  var anchor = document.getElementById('kica-reviews-anchor');
  if (anchor) {
    anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }
  console.log('KICA Anchor not found. Please add the div anchor manually.');
  var loox = document.getElementById('looxReviews');
  if (loox) {
    loox.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    window.scrollTo({ top: document.body.scrollHeight - 1500, behavior: 'smooth' });
  }
};

document.addEventListener('DOMContentLoaded', function () {
  var timerContainer = document.getElementById('js-product-timer');
  if (!timerContainer) return;

  var endTimeStr = timerContainer.getAttribute('data-endtime');
  if (!endTimeStr) return;

  var endTime = new Date(endTimeStr).getTime();
  var interval = null;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function updateTimer() {
    var now = Date.now();
    var distance = endTime - now;

    if (distance < 0) {
      timerContainer.classList.add('timer-hidden');
      if (interval) clearInterval(interval);
      return;
    }

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    var d = document.getElementById('days');
    var h = document.getElementById('hours');
    var m = document.getElementById('minutes');
    var s = document.getElementById('seconds');
    if (d) d.innerText = pad(days);
    if (h) h.innerText = pad(hours);
    if (m) m.innerText = pad(minutes);
    if (s) s.innerText = pad(seconds);
  }

  updateTimer();
  interval = setInterval(updateTimer, 1000);
});
